<template>
    <v-container>
        <v-layout column>
            <v-flex>
                <v-layout row>
                    <v-flex>
                        <v-btn color="success"  @click="backToHeader()">
                            <v-icon right>fast_rewind</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex>
                        <h2>New Issue</h2> 
                    </v-flex>
                </v-layout>

            </v-flex>
            <v-flex v-if="issue"  mt-5>

                <v-layout column>

                    <v-flex>
                        <v-autocomplete
                            :items="issueMaster"
                            item-text="issue"
                            name="issue"
                            v-model="issue.issue"
                            label="Issue"
                            class="ma-0 pa-0"
                        >
                            <template slot='item' slot-scope='{ item }'>
                                {{ item.issue }}
                            </template>

                        </v-autocomplete>

                    </v-flex>

                    <v-flex>
                        <v-autocomplete
                            :items="issueTypes"
                            item-text="issueType"
                            name="issueType"
                            v-model="issue.issueType"
                            label="Issue Type"
                             class="my-2 pa-0"
                        >
                            <template slot='item' slot-scope='{ item }'>
                                {{ item.issueType }}
                            </template>

                        </v-autocomplete>
                    </v-flex>

                    <v-flex>

                        <v-autocomplete
                            :items="issueSubtypes"
                            item-text="subType"
                            name="issueSubtype"
                            v-model="issue.issueSubtype"
                            label="Issue Subtype"
                            class="my-2 pa-0"
                        >
                            <template slot='item' slot-scope='{ item }'>
                                {{ item.subType }}
                            </template>

                        </v-autocomplete>

                    </v-flex>

                    <v-flex>
                        <v-select
                            :items="brands"
                            label="Brand"
                            v-model="issue.brand"
                            class="my-2 pa-0"
                        ></v-select>                        
                    </v-flex>

                    <v-flex v-if="currentUser.hdType == 'PROD'">
                        <v-layout column>
                            <v-flex>
                                <v-text-field
                                    v-model="issue.prodOrderNo"
                                    label="Prod. Order No."
                                ></v-text-field>
                            </v-flex>

                            <v-flex>
                                <v-text-field
                                    v-model="issue.color"
                                    label="Color"
                                ></v-text-field>
                            </v-flex>

                            <v-flex>
                                <v-text-field
                                    v-model="issue.productLine"
                                    label="Product Line"
                                ></v-text-field>
                            </v-flex>

                            <v-flex>
                                <v-text-field
                                    v-model="issue.cutQty"
                                    label="Cut Qty."
                                ></v-text-field>
                            </v-flex>

                            <v-flex>
                                <v-text-field
                                    v-model="issue.affectedQty"
                                    label="Affected Qty."
                                ></v-text-field>
                            </v-flex>

                        </v-layout>
                    </v-flex>

                    <v-flex>
                        <v-autocomplete
                            :items="departments"
                            item-text="department"
                            name="Department"
                            v-model="issue.department"
                            label="Department"
                             class="my-2 pa-0"
                        >
                            <template slot='item' slot-scope='{ item }'>
                                {{ item.department }}
                            </template>

                        </v-autocomplete>
                    </v-flex>

                    <v-flex>
                        <v-select
                            :items="sections"
                            item-text="section"
                            name="Section"
                            v-model="issue.section"
                            label="Section"
                             class="my-2 pa-0"
                        >
                            <template slot='item' slot-scope='{ item }'>
                                {{ item.section }}
                            </template>

                        </v-select>
                    </v-flex>

                    <v-flex>
                        <v-autocomplete
                            :items="locations"
                            item-text="location"
                            name="location"
                            v-model="issue.location"
                            label="Location"
                             class="my-2 pa-0"
                        >
                            <template slot='item' slot-scope='{ item }'>
                                {{ item.location }}
                            </template>

                        </v-autocomplete>

                    </v-flex>

                    <v-flex>
                        <v-textarea
                            solo
                            name="input-7-4"
                            label="Description"
                            v-model="issue.description"
                            ></v-textarea>

                    </v-flex>

                </v-layout>

            </v-flex>

            <v-flex>
                <v-layout row justify-end>
                    <v-flex shrink>
                        <v-btn class="primary" :disabled="disabledBtns"
                            @click="saveIssue()">
                            Save Issue
                        </v-btn>

                    </v-flex>
                    <v-flex shrink ml-5>
                        <v-btn class="warning"   @click="backToHeader">
                            Close
                        </v-btn>

                    </v-flex>
                </v-layout>
            </v-flex>

        </v-layout>


    </v-container>


</template>
<script>

import {mapState,mapActions} from 'vuex'
const fb = require('../../firebaseConfig.js')
export default {
    props:[],
    data(){
        return {
            issue:null
        }
    },
    computed:{
        ...mapState(['currentUser','brands','departments','issueMaster','issueTypes',
            'issueSubtypes','sections','locations'])
    },

    methods:{
        ...mapActions(['setCurrentUser']),
        saveIssue(){
            //console.log("this.currentUser.hdType",this.currentUser.hdType)

            fb.issuesCollection.add({
                hdType:this.$store.state.currentUser.hdType,
                issue: this.issue.issue,
                issueType: this.issue.issueType,
                issueSubtype: this.issue.issueSubtype,
                brand: this.issue.brand,
                department: this.issue.department,
                section: this.issue.section,
                location: this.issue.location,
                description: this.issue.description,
                urgency:'Standard',
                status:'Open',
                prodOrderNo:this.issue.prodOrderNo,
                color:this.issue.color,
                productLine:this.issue.productLine,
                cutQty:this.issue.cutQty,
                affectedQty:this.issue.affectedQty,
                creationDate: new Date(),
                dateID:this.getDateId(),
                assignedTo:'',
                assignedToID:'',
                assignedBy:'',
                assignedDate:new Date("01/01/01"),
                commitmentDate:new Date("01/01/01"),
                raisedBy:this.currentUser.email,
                raisedByID:this.currentUser.userID,
                closedBy:'',
                closeDate:new Date("01/01/01"),
                verifiedCloseBy:'',
                verifiedCloseDate:new Date("01/01/01"),
                solution:'',
                solutionType:'',
                solutionDesc:''
            })
            .then(docRef=>{
                //console.log("docRef issues ", docRef.id);
                if (docRef.id != ''){
                    this.$emit('close',docRef.id)
                }
            })
            .catch(error=>console.log(error))


        },
        getDateId(){

          let dateId = ''
            
          let currentDate = new Date()
          let hours = currentDate.getHours();
          if (hours < 12){
              currentDate.setDate(currentDate.getDate()-1)
          }
          //console.log("currentDate",currentDate);

          dateId  = currentDate.getFullYear() + '' 
              + ( (currentDate.getMonth() + 1) < 10 ? '0'+ (currentDate.getMonth() + 1) : (currentDate.getMonth() + 1) ) 
              + ( currentDate.getDate() < 10 ? '0'+ currentDate.getDate()  : currentDate.getDate() ) 
          
          return dateId;

        },

        backToHeader(){
            this.$emit('close')
        },

    },
    mounted(){
        console.log("Mounted NewIssue");
        //console.log("this.currentUser",this.currentUser.email)
        if ( !this.$store.state.currentUser || this.$store.state.currentUser.userID == ''){

            let currentUser = JSON.parse(localStorage.getItem('currentUser'))

            if (currentUser){
                this.setCurrentUser(currentUser)
            }else{
                this.$router.push('/')
            }
            
        }

        this.issue = {
            issueID:0,
            issue:"",
            issueType:"",
            issueSubtype:"",
            description:"",
            department:"",
            section:"",
            location:"",
            brand:"",
            prodOrderNo:'',
            color:'',
            productLine:'',
            cutQty:0,
            affectedQty:0
        }
    },
    created(){

        console.log("Created NewIssue");




    }
}
</script>
<style scoped>

</style>